import {
  EnergyApiFilter,
  RecentPowerFromEquipmentResponse,
} from '@energybox/react-ui-library/dist/types';
import { Service } from '../config';
import { fetchApi } from '../utils/fetchApi';

export enum Actions {
  GET_ENERGYPRO_BY_SITE_ID_LOADING = '@@energy/GET_ENERGYPRO_BY_SITE_ID_LOADING',
  GET_ENERGYPRO_BY_SITE_ID_ERROR = '@@energy/GET_ENERGYPRO_BY_SITE_ID_ERROR',
  GET_ENERGYPRO_BY_SITE_ID_SUCCESS = '@@energy/GET_ENERGYPRO_BY_SITE_ID_SUCCESS',

  GET_ENERGYPROS_LOADING = '@@energy/GET_ENERGYPROS_LOADING',
  GET_ENERGYPROS_SUCCESS = '@@energy/GET_ENERGYPROS_SUCCESS',
  GET_ENERGYPROS_ERROR = '@@energy/GET_ENERGYPROS_ERROR',

  GET_ENERGY_CO2_EMISSION_BY_SITE_ID_LOADING = '@@energy/GET_ENERGY_CO2_EMISSION_BY_SITE_ID_LOADING',
  GET_ENERGY_CO2_EMISSION_BY_SITE_ID_SUCCESS = '@@energy/GET_ENERGY_CO2_EMISSION_BY_SITE_ID_SUCCESS',
  GET_ENERGY_CO2_EMISSION_BY_SITE_ID_ERROR = '@@energy/GET_ENERGY_CO2_EMISSION_BY_SITE_ID_ERROR',
}

export const setEnergyFilter = (filter?: EnergyApiFilter): string => {
  const queryParams = new URLSearchParams();

  //filter by equipmentId
  if (filter && filter.id) {
    queryParams.set('id', filter.id.toString());
  }

  if (filter && filter.from) {
    queryParams.set('from', filter.from.toString());
  }

  if (filter && filter.to) {
    queryParams.set('to', filter.to.toString());
  }

  if (filter && filter.aggregationLevel) {
    queryParams.set('aggregationLevel', filter.aggregationLevel.toString());
  }

  return queryParams.toString();
};

export const getEnergyCO2EmissionBySiteId = (
  siteId: string | number,
  startDate: string,
  endDate: string
) => ({
  type: 'API_GET',
  service: Service.analytics,
  path: `/report/site_co2_emission_converter/${siteId}/${startDate}/${endDate}`,
  loading: {
    type: Actions.GET_ENERGY_CO2_EMISSION_BY_SITE_ID_LOADING,
    siteId,
  },
  success: {
    type: Actions.GET_ENERGY_CO2_EMISSION_BY_SITE_ID_SUCCESS,
    siteId,
  },
  error: {
    type: Actions.GET_ENERGY_CO2_EMISSION_BY_SITE_ID_ERROR,
    siteId,
  },
});

export const getEnergyPros = () => ({
  type: 'API_GET',
  path: `/api/v1/energy-pro`,
  loading: { type: Actions.GET_ENERGYPROS_LOADING },
  success: { type: Actions.GET_ENERGYPROS_SUCCESS },
  error: { type: Actions.GET_ENERGYPROS_ERROR },
});

export const getEnergyProBySiteId = (siteId: string | number) => ({
  type: 'API_GET',
  path: `/api/v1/energy-pro/site/${siteId}`,
  loading: { type: Actions.GET_ENERGYPRO_BY_SITE_ID_LOADING, siteId },
  success: { type: Actions.GET_ENERGYPRO_BY_SITE_ID_SUCCESS, siteId },
  error: { type: Actions.GET_ENERGYPRO_BY_SITE_ID_ERROR, siteId },
});
